import request from '@/utils/request'

// 错题本

let QuestionErrorApi = {
    
    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.question_error/index', data, errorback);
    },

    /*错题排行榜*/
    ranking(data, errorback) {
        return request._post('/shop/study.question_error/ranking', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.question_error/batch', data, errorback);
    },

    /*易错题排行榜*/
    show(data, errorback) {
        return request._post('/shop/study.question_error_ranking/index', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.question_error_ranking/del', data, errorback);
    },

}

export default QuestionErrorApi;



// WEBPACK FOOTER //
// ./src/api/study/question_error.js